import {GameScreen} from "./GameScreen";

export class GameSplashScreen extends GameScreen {

  public onShowed?:Function | null = null;
  public onHide?:Function | null = null;

  override async onAdded() {
    await super.onAdded();
    this.onShowComplete();
  }

  public hide():void {
    this.onHideComplete();
  }

  protected onShowComplete():void {
    if (this.onShowed) {
      this.onShowed();
      this.onShowed = null;
    }
  }

  protected onHideComplete():void {
    if (this.onHide) {
      this.onHide();
      this.onHide = null;
    }
  }
}
